import script from "./QnaMain.vue?vue&type=script&setup=true&lang=js"
export * from "./QnaMain.vue?vue&type=script&setup=true&lang=js"

import "./QnaMain.vue?vue&type=style&index=0&id=432c9215&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432c9215"]])

export default __exports__